import { computed, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AuthSelectorsFacade } from '@ps/auth-data-access';

import {
  selectCategories,
  selectChildQuestionSearchResults,
  selectCompanies,
  selectDetail,
  selectIsDetailLoading,
  selectIsLoading,
  selectParentQuestionSearchResults,
  selectQuestions,
  selectSearch,
  selectSelectedId,
} from './question.selectors';

@Injectable({ providedIn: 'root' })
export class QuestionSelectorsFacade {
  private readonly _store = inject(Store);
  private readonly _authFacade = inject(AuthSelectorsFacade);

  public readonly questions = this._store.selectSignal(selectQuestions);
  public readonly search = this._store.selectSignal(selectSearch);
  public readonly isLoading = this._store.selectSignal(selectIsLoading);
  public readonly selectedId = this._store.selectSignal(selectSelectedId);
  public readonly detail = this._store.selectSignal(selectDetail);
  public readonly isDetailLoading = this._store.selectSignal(
    selectIsDetailLoading,
  );
  public readonly companies = this._store.selectSignal(selectCompanies);
  public readonly categories = this._store.selectSignal(selectCategories);
  public readonly isOperator = this._authFacade.isOperator;

  public readonly parentQuestionSearchResults = this._store.selectSignal(
    selectParentQuestionSearchResults,
  );
  public readonly childQuestionSearchResults = this._store.selectSignal(
    selectChildQuestionSearchResults,
  );

  // questionLibraryAccessLevel is not yet populated by the backend.
  // Revisit when the full Question Library access-control feature is implemented.
  // `none: () => true` allows access while auth is still loading (optimistic default).
  public readonly hasAccess = computed(() =>
    this._authFacade.user().match({
      some: (u) => u.questionLibraryAccessLevel > 0,
      none: () => true,
    }),
  );

  public readonly canAddQuestion = computed(() =>
    this._authFacade.user().match({
      some: (u) => u.questionLibraryAccessLevel === 1,
      none: () => false,
    }),
  );
}
